import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createHashRouter, RouterProvider } from 'react-router-dom';

import store from './store';
import App from './components/App';
import { SpauthContainer } from './components/SpauthContainer';

// Install the SPauth XHR/fetch JWT patch synchronously at module load,
// before any React render or fetch can fire. The legacy class-based
// SpauthContainer ran this in componentWillMount (sync, pre-render);
// post-React-19 it has to live outside the lifecycle to keep the same
// timing guarantee. SpauthContainer now only handles the login() promise
// and gating the children on user state.
//
// VITE_MOCK=true is the local-dev escape hatch — skip the SPauth init
// chain entirely (cox-spauth.js may not even be loaded against a
// non-whitelisted localhost origin).
if (import.meta.env?.VITE_MOCK !== 'true') {
  window.SPAUTH
    .appId('local')
    .appId('dvs-web')
    .useJWTforXHR();
}

const router = createHashRouter([
  {
    path: '/:siteId?/:folder?/:file?/:diffSource?/:diffTarget?',
    element: <App />,
  },
]);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <SpauthContainer
    renderWithUser={() => (
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    )}
  />,
);
